//removeIf(production)
import ClaroluzOffer from "../../../../../domain/entities/claroluz-offer";
//removeIf(production)
var apiData = {
    contract: '',
};
//endRemoveIf(production)

class ClaroluzContract {
    private cups: string;
    private offer: ClaroluzOffer;

    constructor(cups: string, offer: ClaroluzOffer) {
        this.cups = cups;
        this.offer = offer;
        this.send();
        this.closeClick();
    }

    private send() {
        let url = `${apiData.contract}/${this.cups}/${this.offer.priceId}/${this.offer.distributorId}`;

        // fetch(apiData.old + 'GuestUser/UpdateAccessedContractUserLog?cups=' + this.cups);

        let containerPadding = 40;

        let iframe = document.getElementById('contract-iframe') as HTMLIFrameElement;
        iframe.src = url;
        iframe.style.height = document.querySelector('.claroluz-comparator')!.clientHeight - containerPadding + 'px';

        document.querySelector('.claroluz-comparator')!.classList.add('contract');
    }

    public closeClick() {
        document.querySelector('.claroluz-contract-close')!.addEventListener('click', () => {
            document.querySelector('.claroluz-comparator')!.classList.remove('contract');
        });
    }
}

//removeIf(production)
function appProperties(): import("../../../../../infra/critical/claroluz-events-properties").default {
    throw new Error("Function not implemented.");
}
export default ClaroluzContract;
//endRemoveIf(production)